// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#FoxEss {
  font-family: Arial, sans-serif;
  max-width: 900px; /* Adjust based on your preference */
  margin: auto;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .FoxESS-header {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f9f9f9;
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 4px;
  }

  button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
  }

  button:hover {
    background-color: #0056b3;
  }

  .detailDiv {
    display: none;
    background-color: #f1f1f1;
    padding: 10px;
    margin-top: 10px;
    border-radius: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/FoxEss.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,gBAAgB,EAAE,oCAAoC;EACtD,YAAY;EACZ,aAAa;EACb,wCAAwC;;EAExC;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":["#FoxEss {\n  font-family: Arial, sans-serif;\n  max-width: 900px; /* Adjust based on your preference */\n  margin: auto;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  .FoxESS-header {\n    text-align: center;\n    color: #333;\n    margin-bottom: 20px;\n  }\n\n  ul {\n    list-style: none;\n    padding: 0;\n  }\n\n  li {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f9f9f9;\n    margin-bottom: 10px;\n    padding: 10px;\n    border-radius: 4px;\n  }\n\n  button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n\n  button:hover {\n    background-color: #0056b3;\n  }\n\n  .detailDiv {\n    display: none;\n    background-color: #f1f1f1;\n    padding: 10px;\n    margin-top: 10px;\n    border-radius: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
